<template>

<div id='project-page' class='page'>
	<div>
		<go-back/>
		<h6 class='heading'>{{$t('h-projects')}}</h6>
	</div>


	<div class="page-content">
		<section @click='qwe2'>
            <p>In Progress ...</p>
		
			<div class="hiding">

				<slides :sliders="sliding"></slides>
				<p>qwes</p><br><br>
				<p>qwes</p><br><br>
				<p>qwes</p><br><br>
				<p>qwes</p><br><br>
			</div>
	
		
		</section>
	</div>
	
	<div class="overlay">{{$t('h-projects')}}</div>

		

</div>





</template>


<script>
import GoBack from '@/components/GoBack'
import Slides from '@/components/Slides'


export default {
	data: ()=> {
		return {
			sliding: [
				{title:'Lorem',second:'Ipsum',description:'web dev',img:'img/www_03.jpg'},
				{title:'Craze',second:'Trip',description:'web design',img:'img/www_06.jpg'},
				{title:'Watshu',second:'Meat',description:'Logo Design',img:'img/www_09.jpg'}
				
			],
			qwe: [
				"<img src='img/DSC_9827.jpg'>",
				'qwe',
				'qwe',
				'qwe',
			],
		}	
	},
	methods: {
		qwe2 () {
			console.log(this.qwe);
		}
	},

	components: {
		GoBack,
		Slides,
	
	}
}

</script>

<style lang="scss">
	.hiding {
		display: none;
	}
</style>


